import React from "react";

interface BackupStatusProps {
  error: string | null;
  successMessage: string | null;
  isLoading: boolean;
}

export const BackupStatus: React.FC<BackupStatusProps> = ({
  error,
  successMessage,
  isLoading,
}) => {
  return (
    <>
      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">{error}</div>
      )}

      {successMessage && (
        <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
          {successMessage}
        </div>
      )}

      {isLoading && (
        <div className="mb-4 p-3 bg-blue-100 text-blue-700 rounded">
          Processing...
        </div>
      )}
    </>
  );
};
